export default __webpack_public_path__ + "36f5abc6ad7bf3734f2a5c3a4f33ec90.svg";